import { FunctionComponent } from 'react';
import calculatePercentage from '../../../services/numbers/calculatePercentage';
import Meter from '../../Meter';
import styles from './styles.module.scss';

export type MetricProps = {
    label: string;
    rating: number | null;
};

const Metric: FunctionComponent<MetricProps> = ({ label, rating }) => {
    if (rating === null) {
        return null;
    }

    return (
        <div className={styles.metric}>
            <div className={styles.label}>{label}</div>

            <div className={styles.bar}>
                <Meter
                    className={styles.meter}
                    value={calculatePercentage(rating, 5)}
                    ariaLabel={`${rating} out of 5`}
                />
                {rating}
            </div>
        </div>
    );
};

export default Metric;
